import PropTypes from 'prop-types';
var propTypes = {
  ariaLabel: PropTypes.string,
  hideDivider: PropTypes.bool,
  label: PropTypes.string
};
export default propTypes;